
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface Tool {
  id: string;
  notion_id: string;
  slug: string;
  name: string;
  url: string;
  summary: string;
  category: string[];
  use_cases: string[];
  platforms: string[];
  pricing: string;
  one_time: boolean;
  ai_enabled: boolean;
  tags: string[];
  alternatives: string[];
  logo: string;
  screenshots: string[];
  updated_at: string;
  created_at: string;
}

export function useTools() {
  return useQuery({
    queryKey: ['tools'],
    queryFn: async () => {
      console.log('Fetching tools from Supabase...');
      const { data, error } = await supabase
        .from('tools')
        .select('*')
        .order('name');

      if (error) {
        console.error('Error fetching tools:', error);
        throw error;
      }

      console.log(`Fetched ${data?.length || 0} tools from Supabase`);
      return data as Tool[];
    },
    staleTime: 2 * 60 * 1000, // 2 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
    refetchInterval: 2 * 60 * 1000, // Poll every 2 minutes for fresh data
    refetchOnWindowFocus: true, // Refetch when window gains focus
    refetchOnMount: true, // Always refetch on mount
  });
}

export function useLastSync() {
  return useQuery({
    queryKey: ['last-sync'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('tools')
        .select('updated_at')
        .order('updated_at', { ascending: false })
        .limit(1);

      if (error) {
        console.error('Error fetching last sync:', error);
        throw error;
      }

      return data?.[0]?.updated_at || null;
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
    refetchInterval: 5 * 60 * 1000, // Poll every 5 minutes
  });
}
